/**
 * Editorial section banner used inside the long-form submit page.
 * Each section gets a soft accent block with an eyebrow + title.
 */
export const SectionBanner = ({ eyebrow, title, hint, accent = "bg-roseMilk", testId }) => (
  <div className={`rounded-[2rem] ${accent} px-6 sm:px-10 py-6 sm:py-7`} data-testid={testId}>
    <p className="wit-eyebrow text-raspberry">{eyebrow}</p>
    <h2 className="mt-2 font-serif text-2xl sm:text-3xl text-cocoa leading-tight">
      {title}
    </h2>
    {hint && <p className="mt-3 text-sm text-cocoa/75 leading-relaxed max-w-2xl">{hint}</p>}
  </div>
);

export default SectionBanner;
